<template>
    <div>
        <header class="content__title pl-0">
            <h1>Generic Dashboard</h1>
        </header>

        <div class="alert alert-secondary">
            No dashboard defined for this user type
        </div>
    </div>
</template>

<script>
export default {
  props: ['currentUser'],
  name: 'DashboardGeneric',
};
</script>
